import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Landing = lazy(() => import("@/pages/Landing"));

export const Route = createFileRoute("/start")({
  head: () => seoHead("/start"),
  component: () => <Landing />,
});
